import { createContext } from 'react';
export const FileManagerContext = /*#__PURE__*/createContext({
  iframeLoaded: false
});
export default FileManagerContext;